import { useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { MyCpgPodsState } from '../../pages/mycpg-pods/mycpg-pod-models';
import { setPods, setPodsError } from '../../pages/mycpg-pods/mycpg-pod-slice';
import { TcsmStates } from '../../root/tcsm-model';
import { getMyCpgPodInfo } from '../ducks/mycpg-pod-api';
import { YesNoIndicators } from '../models/api-model';

export function useChurchEmployees(): boolean {
	const dispatch = useDispatch();
	const guid = useSelector<TcsmStates, string>(state => state.authenticatedState.clientGuid);
	const podsState = useSelector<TcsmStates, MyCpgPodsState>(state => state.mycpgPodsState);

	useEffect(() => {	
		if (!podsState.podsLoaded) {
			dispatch(getMyCpgPodInfo(
				(data) => {
					dispatch(setPods(data?.data));
				},
				() => {
					dispatch(setPodsError());
				},
			));
		}
	}, [guid]);

	if (!podsState?.pods?.employment_history_data) {
		return true;
	}

	return podsState.podsLoaded ? podsState?.pods?.employment_history_data?.data.active_church_employee === YesNoIndicators.Yes || podsState?.pods?.employment_history_data?.data.former_church_employee === YesNoIndicators.Yes : false;
}

